import React from 'react';
import cn from 'classnames';
import { create, InstanceProps } from 'react-modal-promise';

import { IconButton } from 'components';
import Modal from 'components/Modal';
import { useAuth } from 'lib/providers/AuthProvider';
import { StudentSocietyAttributes } from 'lib/models/student-society';
import { PAGE_ROUTES } from 'lib/page-routes';
import SignIn from '../SignIn';

import styles from './SignInModal.module.scss';

interface ModalInstanceProps {
  signInFromSociety?: boolean;
  societyInfo?: StudentSocietyAttributes;
}

const ModalInstance: React.FC<
  InstanceProps<boolean | undefined> & ModalInstanceProps
> = ({ isOpen, onResolve, onReject, signInFromSociety, societyInfo }) => {
  const { isTemporaryCandidate } = useAuth();
  const onComplete = (onboarding_completed?: boolean) => {
    if (!signInFromSociety && !onboarding_completed) {
      location.assign(PAGE_ROUTES.CANDIDATE_ONBOARDING);
    }
    onResolve(onboarding_completed);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      contentClassName={styles.container}
    >
      <IconButton
        size="small"
        iconName="close"
        className={styles.cancelIcon}
        onClick={() => onReject()}
      />
      <SignIn
        onComplete={onComplete}
        isLoginPopup={true}
        signInFromSociety={signInFromSociety}
        societyInfo={societyInfo}
        className={cn(
          { [styles.content]: !isTemporaryCandidate },
          { [styles.contentSaveForLater]: isTemporaryCandidate }
        )}
      />
    </Modal>
  );
};

export const signInModalInstance = create(ModalInstance);
